export default {

	namespaced: true,

	state: {

		data: {}

	},

	getters: {

		get: function(state) {

			return state.data

		}

	},

	mutations: {

		add: function(state, e) {

			state.data[e.name] = e.value

		},

		set: function(state, value) {

			state.data = value

		}

	}

}